import styled from "@emotion/styled";
import Card from "@snapchat/snap-design-system/es/components/Card";
import { Black } from "@snapchat/snap-design-system/es/constants/colors";
import { Heading, Paragraph } from "@snapchat/snap-design-system/es/constants/fonts";

export const ErrorInfoCard = styled(Card)`
    width: 70%;
`;

export const ErrorTitle = styled.span`
    margin: 40px 0 16px 0;
    ${Heading.H400}
`;

export const Description = styled.span`
    ${Paragraph.P200}
    color:${Black.V50};
    margin-bottom: 24px;
`;
